import { render, staticRenderFns } from "./HistoryItemJob_skillsheet.vue?vue&type=template&id=2995ba67&scoped=true"
import script from "./HistoryItemJob_skillsheet.vue?vue&type=script&lang=js"
export * from "./HistoryItemJob_skillsheet.vue?vue&type=script&lang=js"
import style0 from "./HistoryItemJob_skillsheet.vue?vue&type=style&index=0&id=2995ba67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995ba67",
  null
  
)

export default component.exports